var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "AppModal",
    {
      attrs: {
        id: _vm.id,
        options: _vm.options,
        title: "Are you sure you want to log out?"
      }
    },
    [
      _c(
        "p",
        { staticClass: "text-gray-700 text-sm leading-relaxed" },
        [
          _vm._v(" You are "),
          _c(
            "BaseLink",
            {
              on: {
                click: function($event) {
                  return _vm.$ui.openFileMarkdownModal("application-storage")
                }
              }
            },
            [_vm._v(" using browser storage ")]
          ),
          _vm._v(" and "),
          _c("strong", [_vm._v("your data will be deleted")]),
          _vm._v(
            " when you log out. If you want to make sure that it isn't lost, you can "
          ),
          _c(
            "BaseLink",
            {
              on: {
                click: function($event) {
                  return _vm.$media.exportCollection()
                }
              }
            },
            [_vm._v(" export your collection ")]
          ),
          _vm._v(
            " and you'll be able to import it later (using JSON-LD import). "
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex justify-end mt-4" },
        [
          _c(
            "BaseButton",
            {
              staticClass:
                "text-primary-700 border border-primary-500 mr-2 hover:bg-black-overlay",
              on: { click: _vm.close }
            },
            [_vm._v(" Cancel ")]
          ),
          _c(
            "BaseButton",
            {
              staticClass: "text-white bg-red-500 hover:bg-red-700",
              on: {
                click: function($event) {
                  _vm.$auth.logout(true) && _vm.close()
                }
              }
            },
            [_vm._v(" Log out ")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }